import { memo } from 'react';
import { HEADER_ROW_HEIGHT } from '../../utils/boardHelpers';
import type { YearSpan } from './timelineHeaderHelpers';

interface TimelineYearRowProps {
  yearSpans: YearSpan[];
  dayWidth: number;
  isLast: boolean;
}

export const TimelineYearRow = memo(function TimelineYearRow({ yearSpans, dayWidth, isLast }: TimelineYearRowProps) {
  return (
    <div
      style={{
        position: 'relative',
        height: HEADER_ROW_HEIGHT,
        borderBottom: isLast ? undefined : '1px solid #f1f5f9',
      }}
    >
      {yearSpans.map((span) => {
        const width = (span.endDay - span.startDay) * dayWidth;
        return (
          <div
            key={`year-${span.year}`}
            style={{
              position: 'absolute',
              left: span.startDay * dayWidth,
              top: 0,
              width,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11,
              fontWeight: 700,
              color: '#1e293b',
              borderRight: '2px solid #cbd5e1',
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
            }}
          >
            {width >= 30 ? String(span.year) : ''}
          </div>
        );
      })}
    </div>
  );
});
